import { Result } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { useAppSelector } from "../../../../hooks/use-app-selector.ts"
import { MemberPerformancePage } from "./MemberPerformancePage"

// The page exists only where the company has the feature and the user holds
// team_performance_view — the same answer `/me` gives the tab.
export function MemberPerformanceRoute() {
  const { t } = useTranslation()
  const allowed = useAppSelector(
    (state) => !!state.auth.userInfo?.feature_team_performance
  )
  if (!allowed)
    return <Result status="403" title={t("teamPerformance.member.notFound")} />
  return <MemberPerformancePage />
}
